import type { TestContext } from 'yup';

export function uniqueArray(this: TestContext, value: any) {
  if (!Array.isArray(value)) return false;

  return new Set(value).size === value.length;
}
